/**
 * Scroll Icons: stagger-in animation on scroll.
 * Only runs if .scroll-icons__item elements exist.
 */
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

export function initScrollIconsAnimations() {
	const items = document.querySelectorAll(".scroll-icons__item");
	if (!items.length) return;

	items.forEach((item) => {
		const link = item.querySelector(".scroll-icons__link");
		const text = item.querySelector(".scroll-icons__text");
		const targets = [link, text].filter(Boolean);
		if (!targets.length) return;

		gsap.set(targets, { opacity: 0, y: 28, x: 24 });

		gsap.to(targets, {
			opacity: 1,
			y: 0,
			x: 0,
			duration: 0.65,
			ease: "power2.out",
			stagger: 0.07,
			scrollTrigger: {
				trigger: item,
				start: "top 88%",
				toggleActions: "play none none none",
			},
		});
	});
}
